/**
 * AddItemButton - Reusable button for adding modules/submodules
 * Designed to be extensible for TAN-4360 (rename) with similar styling
 */
import Button from '../../../../atoms/Button/Button';
import React from 'react';

type AddItemButtonProps = {
  label: string;
  onClick: () => void;
  variant?: 'module' | 'submodule';
  disabled?: boolean;
};

function AddItemButton({ label, onClick, variant = 'module', disabled = false }: AddItemButtonProps): JSX.Element {
  return (
    <Button className={`add-item-button add-item-button--${variant}`} variant="primary-outline" onClick={onClick} isDisabled={disabled} text={`+ ${label}`} isFullWidth />
  );
}

export default AddItemButton;
